import script from "./PresenterView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PresenterView.vue?vue&type=script&lang=ts&setup=true"

import "./PresenterView.vue?vue&type=style&index=0&id=5fba3eec&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fba3eec"]])

export default __exports__